// @flow
import WebComponent from '../webComponents/WebComponent';

/**
 * Komponenta nastaví do hlavního labelu hodnotu labelu aktuálně vybrané radio komponenty
 *
 */
export default class RadioSelectTab extends WebComponent {
	constructor(props) {
		super(props);
		this.setActiveRadioLabel = this.setActiveRadioLabel.bind(this);
		this.handleLabelClick = this.handleLabelClick.bind(this);
	};

	didMount() {
		const {
			targetSelector,
			labelSelector,
			radioSelector,
			activeClass,
		} = this.props;

		this.me = document.querySelector(targetSelector);
		this.label = this.me.querySelector(labelSelector);
		this.radios = this.me.querySelectorAll(radioSelector);
		this.activeClass = activeClass;

		Array.from(this.radios).forEach(target => {
			target.addEventListener('click', this.setActiveRadioLabel);
		});

		this.label.addEventListener('click', this.handleLabelClick);

		this.setActiveRadioLabel();
	};

	setActiveRadioLabel() {
		const self = this;

		let activeRadio = null,
				activeLabel = null;

		Array.from(this.radios).forEach(target => {
			if (target.checked) {
				activeRadio = target.getAttribute('id');
			}
		});

		if (activeRadio) {
			activeLabel = self.element.querySelector('label[for="' + activeRadio + '"]');

			this.label.innerHTML = (activeLabel.textContent || activeLabel.innerText);
		}
	};

	handleLabelClick() {
		this.me.classList.toggle(this.activeClass);
	};
}

RadioSelectTab.defaultProps = {
	labelSelector: '.control-label',
	radioSelector: 'input[type=radio]',
	activeClass: 'active',
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/RadioSelectTab.js